var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.25V4.75C19 3.78167 18.291 3 17.4127 3H2.5873C1.70899 3 1 3.78167 1 4.75V15.25C1 16.2183 1.70899 17 2.5873 17H17.4127C18.291 17 19 16.2183 19 15.25ZM17.6138 4.62167C17.963 5.00667 17.7725 5.40333 17.582 5.60167L13.2857 9.94167L17.4127 14.6783C17.5397 14.8417 17.6243 15.0983 17.4762 15.2733C17.3386 15.46 17.0212 15.4483 16.8836 15.3317L12.2593 10.98L9.99471 13.255L7.74074 10.98L3.1164 15.3317C2.97884 15.4483 2.66138 15.46 2.52381 15.2733C2.37566 15.0983 2.46032 14.8417 2.5873 14.6783L6.71429 9.94167L2.41799 5.60167C2.22751 5.40333 2.03704 5.00667 2.38624 4.62167C2.73545 4.23667 3.09524 4.42333 3.39153 4.70333L9.99471 10.5833L16.6085 4.70333C16.9048 4.42333 17.2646 4.23667 17.6138 4.62167Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.ccaf91328e9fddb80df1b335fba05d3a.svg";
export { ForwardRef as ReactComponent };